export default "__VITE_ASSET__DhcteEHz__"